import React, {useState} from 'react'
import PropTypes from 'prop-types'
import ListActivity from "./ListActivity"

BlockRight.propTypes = {
    custId: PropTypes.string
}

function BlockRight(props) {
    const {custId} = props
    const [activeTab, setActiveTab] = useState('activity')

    const _handleChangeTab = (value) => {
        setActiveTab(value)
    }

    return (
        <div className="BlockRight">
            <div className="AccordionItem p-3">
                <div className="TabNav">
                    <ul>
                        <li className={`${activeTab === 'activity' ? 'Active' : ''}`}
                            onClick={() => _handleChangeTab('activity')}>
                            Activity
                        </li>
                    </ul>
                </div>
                <div className="ContentTab">
                    <ListActivity custId={custId}/>
                </div>
            </div>
        </div>
    )
}

export default BlockRight